import { useQuery } from '@tanstack/react-query'

import { graphqlClient } from '../client'
import type {
  DeviceTypeCategory,
  GetStudioDevicesQuery,
} from '../codegen/graphql'
import { GetStudioDevicesDocument } from '../codegen/graphql'

export type StudioDeviceSummary =
  GetStudioDevicesQuery['studioDevices'][number] & {
    type: DeviceTypeCategory
  }

export const studioDevicesQueryKey = ['studioDevices'] as const

/**
 * Lightweight device list for studio canvas.
 *
 * Hits the BFF's `studioDevices` resolver: a single DB read with the
 * minimum fields the canvas needs (id, name, vendor, model, maxCapacity,
 * category, controllerId, connectedDeviceIds). No MM RPCs.
 *
 * Connection status arrives separately via
 * {@link useDeviceConnectionStatuses} so the canvas renders immediately.
 */
export function useStudioDevices() {
  return useQuery({
    queryKey: studioDevicesQueryKey,
    queryFn: async () => {
      const response = await graphqlClient.request<GetStudioDevicesQuery>(
        GetStudioDevicesDocument,
      )
      return response.studioDevices.map(
        (d): StudioDeviceSummary => ({
          ...d,
          type: d.category,
        }),
      )
    },
  })
}
